import { render, staticRenderFns } from "./MyLeads.vue?vue&type=template&id=777c6dd1&scoped=true&"
import script from "./MyLeads.vue?vue&type=script&lang=js&"
export * from "./MyLeads.vue?vue&type=script&lang=js&"
import style0 from "./MyLeads.vue?vue&type=style&index=0&id=777c6dd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c6dd1",
  null
  
)

export default component.exports